import axios from 'axios'

export default {
  async fetchPours({ commit }, { project, from, to, limit } = {}) {
    const { data } = await axios.get('/chantier/concrete', {
      params: { project, from, to, limit },
    })
    commit('updatePours', data.pours)
  },

  async fetchPour({ commit }, woConcreteGid) {
    const { data } = await axios.get(`/chantier/concrete/${woConcreteGid}`)
    commit('updatePour', data.pour)
  },
}
